import { HANDBAGS_CATEGORY } from "../../../../constants/kickavenue";

export function isAllLuxuryItem(categories = []) {
  for (const category of categories) {
    if (category !== HANDBAGS_CATEGORY) {
      return false;
    }
  }
  return true;
}

export function isKaVenuePaymentMethod(paymentMethod) {
  if (!paymentMethod || typeof paymentMethod !== 'string') {
    return false;
  }
  
  return paymentMethod.toLowerCase().includes('_kavenue');
}

export function getInvoiceBillFrom(paymentMethod) {
  if (isKaVenuePaymentMethod(paymentMethod)) {
    return 'K-Avenue Grand Indonesia';
  }
  return 'Kick Avenue';
}
